import {CaregiverRoutes} from '../../../../../../components/caregiver-routes/caregiver-routes';
import {CaregiverMode} from '../../../../../../enums';

export default function ProfessionalCaregiverProfessionalCaregiverOfficeScreen() {
  return <CaregiverRoutes caregiverMode={CaregiverMode.Professional} />;
}
